import React from 'react';
import { Button, Result } from 'antd';
import { redirect } from 'react-router-dom';

const App: React.FC = () => (
  <Result
    status="404"
    title="404"
    subTitle="Sorry, the page you visited does not exist."
    extra={<Button type="primary" onClick={() => redirect('/')}>Back Home</Button>}
  />
);

export default App;